import React from 'react';
import { UserIcon } from 'lucide-react';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import { rosterSlots } from '../../data/influencerRoster';
export function Roster() {
  return <section className="border-b border-brand-gray300 bg-brand-black py-[clamp(70px,10vw,140px)] text-brand-white" data-id="element-131" data-mp="2g471oythfxm0">
      <Container data-id="element-132" data-mp="2c44zmoju5267">
        <div className="mb-[clamp(40px,6vw,80px)] flex flex-wrap items-end justify-between gap-[40px]" data-id="element-133" data-mp="2c1isur4rqqp1">
          <div className="self-start" data-id="element-134" data-mp="1obyaa9cj1vga">
            <span className="font-mono text-[12px] uppercase tracking-[0.18em] text-white/60" data-id="element-135" data-mp="1jfhhv2yaouxe">
              02 · Currently representing
            </span>
            <p className="mt-5 max-w-[30ch] text-[16px] leading-[1.5] text-white/80" data-id="element-136" data-mp="1x8h0hdtdj596">
              Our first signings are being finalized now.
            </p>
          </div>
          <h2 className="max-w-[18ch] text-[clamp(2.2rem,5.6vw,5.2rem)] font-black leading-[0.95] tracking-[-0.025em] text-brand-white" data-id="element-137" data-mp="14oif48k550lq">
            The roster starts here.
          </h2>
        </div>

        <div className="grid grid-cols-4 gap-px bg-white/15 max-[900px]:grid-cols-2 max-[520px]:grid-cols-1" data-id="element-138" data-mp="346nfeq2ty58e">
          {rosterSlots.map((slot, index) => <Reveal key={slot.id} delay={index * 0.04} className="h-full" data-id="element-139" data-mp="3dwgh8zd675zg" data-mpi={index}>
              <article className="flex h-full flex-col bg-brand-black" data-id="element-140" data-mp="3iw3502qmk4mi">
                <div className="relative aspect-[4/5] overflow-hidden bg-white/[0.06]" data-id="element-141" data-mp="3ivb7gmdgvwtl">
                  {slot.image ? <img src={slot.image} alt={slot.name ?? 'Roster talent'} className="h-full w-full object-cover" loading="lazy" data-id="element-142" data-mp="2q7fe9rn3wn1k" /> : <div className="flex h-full w-full items-center justify-center" data-id="element-143" data-mp="307695ufkx426">
                      <UserIcon size={64} strokeWidth={1} className="text-white/20" aria-hidden="true" data-id="element-144" data-mp="afhtae6lyxfp" />
                    </div>}
                </div>
                <div className="flex flex-1 flex-col p-[24px]" data-id="element-145" data-mp="26icrlxddmqft">
                  <h3 className="text-[clamp(1.1rem,1.5vw,1.4rem)] font-black uppercase tracking-[-0.015em]" data-id="element-146" data-mp="2kj74as7gjdka">
                    {slot.name ?? 'New signing'}
                  </h3>
                  <p className="mt-2 text-[14px] leading-[1.5] text-white/70" data-id="element-147" data-mp="2gfr7nvve1d7l">
                    {slot.niche ?? 'Roster launching soon'}
                  </p>
                  <div className="mt-auto flex items-center justify-between gap-3 pt-6 font-mono text-[11px] uppercase tracking-[0.14em] text-white/50" data-id="element-148" data-mp="1nu7qkxo3tjkp">
                    <span data-id="element-149" data-mp="1wtmepqgsti21">{slot.platform ?? 'Platform TBA'}</span>
                    <span data-id="element-150" data-mp="1wsbeu1qh4ug7">{slot.followers ?? '—'}</span>
                  </div>
                </div>
              </article>
            </Reveal>)}
        </div>
      </Container>
    </section>;
}